import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-growth',
  templateUrl: './our-growth.component.html',
  styleUrls: ['./our-growth.component.scss']
})
export class OurGrowthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
